var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B363B",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    d: "M16 27.7c6.186 0 11.2-5.014 11.2-11.2 0-6.186-5.014-11.2-11.2-11.2-6.186 0-11.2 5.014-11.2 11.2 0 6.186 5.014 11.2 11.2 11.2Zm0 2.4c7.511 0 13.6-6.089 13.6-13.6 0-7.511-6.089-13.6-13.6-13.6-7.511 0-13.6 6.089-13.6 13.6 0 7.511 6.089 13.6 13.6 13.6Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B363B",
    fillOpacity: 0.5,
    d: "M17.6 10.1a1.6 1.6 0 1 1-3.2 0 1.6 1.6 0 0 1 3.2 0ZM14.4 14.9a1.6 1.6 0 0 1 3.2 0v8a1.6 1.6 0 1 1-3.2 0v-8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.529405c34a15cecca5f4d9c19634e61f.svg";
export { ForwardRef as ReactComponent };